import { Tag } from "antd";
import { capitalize } from "lodash";
import moment from "moment";
import emptyUser from "../../../assets/images/empty_user.jpg";
import CustomModal from "../../../components/ui/CustomModal";
import { TransactionsDetails } from "../../../types/bsrm/statements";
import { formatSouthAsianNumber } from "../../../utils/utils";

interface ModalComponentProps<DataT = never, TypeT = never> {
  open: boolean;
  handleClose: (val?: any) => void;
  type?: "ADD" | "UPDATE" | "VIEW" | TypeT;
  data?: any;
  selectedCategory?: string;
}

const StatementDetailsModal = ({
  handleClose,
  type,
  data,
  selectedCategory,
  ...rest
}: ModalComponentProps<TransactionsDetails>) => {
  const statementDetails =
    selectedCategory === "dealer"
      ? [
          { label: "Zone", value: data?.merchant?.zone ?? "N/A" },
          { label: "District", value: data?.merchant?.district ?? "N/A" },
          {
            label: "Date",
            value: data?.paymentCreatedAt
              ? moment(data?.paymentCreatedAt).format("DD/MM/YYYY")
              : "n/a",
          },
          {
            label: "Time",
            value: data?.paymentCreatedAt
              ? moment(data?.paymentCreatedAt).format("hh:mm A")
              : "n/a",
          },
          { label: "Business Unit", value: data?.businessUnit?.name ?? "N/A" },
          {
            label: "Amount",
            value: "৳" + formatSouthAsianNumber(data?.amount || 0),
          },
          { label: "Sheba Pay Trx. ID", value: data?.transactionId ?? "N/A" },
          {
            label: "Sheba payment status",
            value: data?.status,
            isStatus: true,
          },
          {
            label: "Bank name",
            value: data?.businessUnit?.bankName ?? "N/A",
          },
          {
            label: "Bank account",
            value: data?.businessUnit?.bankAccountNo ?? "N/A",
          },
          {
            label: "Bank Transfer",
            value: data?.mStatus,
            isStatus: true,
          },
          {
            label: "Bank Transaction ID",
            value: data?.bankTransactionId ?? "N/A",
          },
          { label: "BSRM MR ID", value: data?.omrId ?? "N/A" },
          {
            label: "BSRM MR Status",
            value: data?.omrStatus,
            isStatus: true,
          },
          {
            label: "Wallet Number",
            value: data?.merchant?.merchantMsisdn ?? "N/A",
          },
        ]
      : selectedCategory === "trader"
      ? [
          { label: "Zone", value: data?.merchant?.zone ?? "N/A" },
          { label: "District", value: data?.merchant?.district ?? "N/A" },
          {
            label: "Date",
            value: data?.paymentCreatedAt
              ? moment(data?.paymentCreatedAt).format("DD/MM/YYYY")
              : "n/a",
          },
          {
            label: "Time",
            value: data?.paymentCreatedAt
              ? moment(data?.paymentCreatedAt).format("hh:mm A")
              : "n/a",
          },
          { label: "Business Unit", value: data?.businessUnit?.name ?? "N/A" },
          {
            label: "Amount",
            value: "৳" + formatSouthAsianNumber(data?.amount || 0),
          },
          { label: "Sheba Pay Trx. ID", value: data?.transactionId ?? "N/A" },
          {
            label: "Sheba payment status",
            value: data?.status,
            isStatus: true,
          },
          {
            label: "Bank name",
            value: data?.businessUnit?.bankName ?? "N/A",
          },
          {
            label: "Bank account",
            value: data?.businessUnit?.bankAccountNo ?? "N/A",
          },
          {
            label: "Bank Transfer",
            value: data?.mStatus,
            isStatus: true,
          },
          {
            label: "Bank Transaction ID",
            value: data?.bankTransactionId ?? "N/A",
          },
          { label: "BSRM MR ID", value: data?.omrId ?? "N/A" },
          {
            label: "BSRM MR Status",
            value: data?.omrStatus,
            isStatus: true,
          },
          {
            label: "Wallet Number",
            value: data?.merchant?.merchantMsisdn ?? "N/A",
          },
        ]
      : selectedCategory === "retailer"
      ? [
          { label: "Zone", value: data?.merchant?.zone ?? "N/A" },
          { label: "District", value: data?.merchant?.district ?? "N/A" },
          {
            label: "Date",
            value: data?.paymentCreatedAt
              ? moment(data.paymentCreatedAt).format("DD/MM/YYYY")
              : "n/a",
          },
          {
            label: "Time",
            value: data?.paymentCreatedAt
              ? moment(data.paymentCreatedAt).format("hh:mm A")
              : "n/a",
          },
          { label: "Business Unit", value: data?.businessUnit?.name ?? "N/A" },
          {
            label: "Amount",
            value: "৳" + formatSouthAsianNumber(data?.amount || 0),
          },
          {
            label: "Retailer Name",
            value: data?.retailer?.profile?.merchantName ?? "N/A",
          },
          {
            label: "Retailer Wallet Number",
            value: data?.retailer?.profile?.merchantNumber ?? "N/A",
          },
          {
            label: "Register Merchant Wallet Number",
            value: data?.merchant?.merchantMsisdn ?? "N/A",
          },
          { label: "Sheba Pay Trx. ID", value: data?.transactionId ?? "N/A" },
          {
            label: "Sheba payment status",
            value: data?.status,
            isStatus: true,
          },
          {
            label: "Bank name",
            value: data?.businessUnit?.bankName ?? "N/A",
          },
          {
            label: "Bank account",
            value: data?.businessUnit?.bankAccountNo ?? "N/A",
          },
          {
            label: "Bank Transfer",
            value: data?.mStatus ?? "N/A",
            isStatus: true,
          },
          {
            label: "Bank Transaction ID",
            value: data?.bankTransactionId ?? "N/A",
          },
          {
            label: "Status Time",
            value: data?.spayTransferAt
              ? moment(data?.spayTransferAt).format("hh:mm A")
              : "n/a",
          },
          { label: "BSRM MR ID", value: data?.omrId ?? "N/A" },
          {
            label: "BSRM MR Status",
            value: data?.omrStatus,
            isStatus: true,
          },
        ]
      : [];

  return (
    <CustomModal {...rest} handleClose={handleClose} width={460} footer={null}>
      {selectedCategory === "dealer" && (
        <div className="p-4">
          <div className="flex items-center space-x-3">
            <>
              <img
                src={data?.merchant?.profile?.logoImage}
                alt="User"
                className="w-14 h-14 rounded-full"
              />
              <div>
                <h2 className="text-lg font-semibold">{data?.merchant.name}</h2>
                <p className="text-gray-500 text-sm">
                  Dealer code:{" "}
                  {data?.merchant.dealerNo ? data?.merchant.dealerNo : "N/A"}
                </p>
              </div>
            </>
          </div>
          <div className="mt-4 space-y-2 text-sm text-gray-700">
            <>
              {statementDetails.map((item, index) => (
                <div
                  key={index}
                  className="flex justify-between py-2"
                  style={{
                    borderBottom:
                      index !== statementDetails.length - 1
                        ? "1px solid #E9EFF6"
                        : "none",
                  }}
                >
                  <div>{item.label}:</div>{" "}
                  {item.isStatus ? (
                    <Tag
                      color={
                        item?.value === "success" || item?.value === "approved"
                          ? "success"
                          : item?.value === "failed"
                          ? "error"
                          : "warning"
                      }
                      className="rounded-full"
                      bordered={false}
                    >
                      {capitalize(
                        item?.value === "success"
                          ? "success"
                          : item?.value === "approved"
                          ? "approved"
                          : item?.value === "failed"
                          ? "failed"
                          : "pending"
                      )}
                    </Tag>
                  ) : item?.value === null ||
                    item?.value === undefined ||
                    item?.value === "" ? (
                    "N/A"
                  ) : (
                    item?.value
                  )}
                </div>
              ))}
            </>
          </div>
        </div>
      )}

      {selectedCategory === "trader" && (
        <div className="p-4">
          <div className="flex items-center space-x-3">
            <>
              <img
                src={data?.merchant?.profile?.logoImage}
                alt="User"
                className="w-14 h-14 rounded-full"
              />
              <div>
                <h2 className="text-lg font-semibold">{data?.merchant.name}</h2>
                <p className="text-gray-500 text-sm">
                  Trader code:{" "}
                  {data?.merchant.dealerNo ? data?.merchant.dealerNo : "N/A"}
                </p>
              </div>
            </>
          </div>
          <div className="mt-4 space-y-2 text-sm text-gray-700">
            <>
              {statementDetails.map((item, index) => (
                <div
                  key={index}
                  className="flex justify-between py-2"
                  style={{
                    borderBottom:
                      index !== statementDetails.length - 1
                        ? "1px solid #E9EFF6"
                        : "none",
                  }}
                >
                  <div>{item.label}:</div>{" "}
                  {item.isStatus ? (
                    <Tag
                      color={
                        item?.value === "success" || item?.value === "approved"
                          ? "success"
                          : item?.value === "failed"
                          ? "error"
                          : "warning"
                      }
                      className="rounded-full"
                      bordered={false}
                    >
                      {capitalize(
                        item?.value === "success"
                          ? "success"
                          : item?.value === "approved"
                          ? "approved"
                          : item?.value === "failed"
                          ? "failed"
                          : "pending"
                      )}
                    </Tag>
                  ) : item?.value === null ||
                    item?.value === undefined ||
                    item?.value === "" ? (
                    "N/A"
                  ) : (
                    item?.value
                  )}
                </div>
              ))}
            </>
          </div>
        </div>
      )}

      {selectedCategory === "retailer" && (
        <div className="p-4">
          <div className="flex items-center space-x-3">
            <>
              <img
                src={data?.retailer?.profile?.logoImage || emptyUser}
                alt="User"
                className="w-14 h-14 rounded-full"
              />
              <div>
                <h2 className="text-lg font-semibold">
                  {data?.retailer?.profile?.merchantName}
                </h2>
                <p className="text-gray-500 text-sm">
                  Register Merchant code:{" "}
                  {data?.merchant?.dealerNo ? data?.merchant?.dealerNo : "N/A"}
                </p>
              </div>
            </>
          </div>
          <div className="mt-4 space-y-2 text-sm text-gray-700">
            <>
              {statementDetails.map((item, index) => (
                <div
                  key={index}
                  className="flex justify-between py-2"
                  style={{
                    borderBottom:
                      index !== statementDetails.length - 1
                        ? "1px solid #E9EFF6"
                        : "none",
                  }}
                >
                  <div>{item.label}:</div>{" "}
                  {item.isStatus ? (
                    <Tag
                      color={
                        item?.value === "success" || item?.value === "approved"
                          ? "success"
                          : item?.value === "failed"
                          ? "error"
                          : "warning"
                      }
                      className="rounded-full"
                      bordered={false}
                    >
                      {capitalize(
                        item?.value === "success"
                          ? "success"
                          : item?.value === "approved"
                          ? "approved"
                          : item?.value === "failed"
                          ? "failed"
                          : "pending"
                      )}
                    </Tag>
                  ) : item?.value === null ||
                    item?.value === undefined ||
                    item?.value === "" ? (
                    "N/A"
                  ) : (
                    item?.value
                  )}
                </div>
              ))}
            </>
          </div>
        </div>
      )}
    </CustomModal>
  );
};

export default StatementDetailsModal;
